module.exports = __webpack_public_path__ + "static/media/shareLockGuide4_Jap.f43ede09.jpg";